import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

// layout
import AuthLayout from "../views/auth-layout/index.vue";
import UnAuthLayout from "../views/unauth-layout/index.vue";

import Home from "../views/home.vue";

// Auth
import Login from "@/views/auth/login.vue";
import Register from "@/views/auth/register.vue";
import ForgotPassword from "@/views/auth/forgot-password.vue";

// Values
// import ValuesUpload from "@/views/values/upload.vue";
import Values from "@/views/values/index.vue";
import ValueCreate from "@/views/values/create.vue";
import ValueId from "@/views/values/id.vue";

// ValueLists
// import ValueListUpload from "@/views/value-lists/upload.vue";
import ValueLists from "@/views/value-lists/index.vue";
import ValueListCreate from "@/views/value-lists/create.vue";
import ValueListId from "@/views/value-lists/id.vue";

// ValueListDetails
// import ValueListUpload from "@/views/value-lists/upload.vue";
import ValueListDetails from "@/views/value-list-details/index.vue";
import ValueListDetailCreate from "@/views/value-list-details/create.vue";
import ValueListDetailId from "@/views/value-list-details/id.vue";

// Safety Managemnet
// Report Types
import ReportTypes from "@/views/safety-management/report-types/index.vue";
// Accident Types
import AccidentTypes from "@/views/safety-management/accident-types/index.vue";
// Accident Root Cause Types
import AccidentRootCauseTypes from "@/views/safety-management/accident-root-cause-types/index.vue";
// Accident Preventive Action Categories
import AccidentPreventiveActionCategories from "@/views/safety-management/accident-preventive-action-categories/index.vue";
// Near Miss Categories
import NearMssCategories from "@/views/safety-management/near-miss-categories/index.vue";
// Audit Types
import AuditTypes from "@/views/safety-management/audit-types/index.vue";
import AuditTypeDetails from "@/views/safety-management/audit-types/details.vue";
// Internal Audit Types
import InternalAuditTypes from "@/views/safety-management/internal-audit-types/index.vue";
// Audit Categories
import AuditCategories from "@/views/safety-management/audit-categories/index.vue";
// Drill Categories
import DrillCategories from "@/views/safety-management/drill-categories/index.vue";
// Basis of CAR
import BasisOfCar from "@/views/safety-management/basis-of-cars/index.vue";
// Emergency Company Types
import EmergencyCompanyTypes from "@/views/safety-management/emergency-company-types/index.vue";
// Master Handing/Taking Over Checklist
import MasterHandingTakingOverChecklist from "@/views/safety-management/master-handing-taking-over-checklist/index.vue";
// Officer & Engineer Handing/Taking Over Checklist
import OffcerEngineerHandingTakingOverChecklist from "@/views/safety-management/officer-enginner-handing-taking-over-checklist/index.vue";
// Safety Meeting Agenda
import SafetyMeetingAgenda from "@/views/safety-management/safety-meeting-agendas/index.vue";
// Masters Management Agenda
import MastersManagementAgenda from "@/views/safety-management/masters-management-agendas/index.vue";
// Locations on Board
import LocationsOfBoard from "@/views/safety-management/locations-on-boards/index.vue";
// VIQ Number
import VIQNumber from "@/views/safety-management/viq-numbers/index.vue";
// Type of operation
import TypesOfOperation from "@/views/safety-management/types-of-operations/index.vue";
// Type of Training
import TypesOfTraining from "@/views/safety-management/types-of-trainings/index.vue";
// Potential Incident Category
import PotentialIncidentCategories from "@/views/safety-management/potential-incident-categories/index.vue";
// Type of injury
import TypeOfInjury from "@/views/safety-management/type-of-injuries/index.vue";
// Company / Service Line
import CompanyServiceLine from "@/views/safety-management/company-service-lines/index.vue";
// Category Oceaneering - Cards
import CategoryOceaneeringCards from "@/views/safety-management/category-oceaneering-cards/index.vue";
// High Hazard Task Observation
import HighHazardTaskObservation from "@/views/safety-management/high-hazard-task-observations/index.vue";
// Observation Category
import ObservationCategories from "@/views/safety-management/observation-categories/index.vue";
// Evaluation Types
import EvalutionTypes from "@/views/safety-management/evalution-types/index.vue";
// Syllabus for Training Evaluation
import SyllabusForTrainingEvalution from "@/views/safety-management/syllabus-for-training-evalutions/index.vue";
// NC Category
import NCCategories from "@/views/safety-management/nc-categories/index.vue";
// MNC Category
import MNCCategories from "@/views/safety-management/mnc-categories/index.vue";
// Injury Category
import InjuryCategories from "@/views/safety-management/injury-categories/index.vue";
// Observation Category
import MainObservationCategories from "@/views/safety-management/main-observation-categories/index.vue";
// Vessel Certificate Category
import VesselCertificateCategories from "@/views/safety-management/vessel-certificate-categories/index.vue";
// Vessel Certificate Names
import VesselCertificateNames from "@/views/safety-management/vessel-certificate-names/index.vue";

// Procurement Categories
//Supplier Types
import SupplierTypes from "@/views/procurement-management/supplier-types/index.vue";
//Requisition nature
import RequisitionNatures from "@/views/procurement-management/requisition-natures/index.vue";
//Invoice Discrepancy Reason
import InvoiceDiscrepancyReasons from "@/views/procurement-management/invoice-discrepancy-reasons/index.vue";
//Expenses category
import ExpensesCategories from "@/views/procurement-management/expenses-categories/index.vue";
//Buyers
import Buyers from "@/views/procurement-management/buyers/index.vue";
import BuyerCreate from "@/views/procurement-management/buyers/create.vue";
import BuyerId from "@/views/procurement-management/buyers/id.vue";
//Parent Account Code Groups
import ParentAccountCodeGroups from "@/views/procurement-management/parent-account-code-groups/index.vue";
import ParentAccountCodeGroupCreate from "@/views/procurement-management/parent-account-code-groups/create.vue";
import ParentAccountCodeGroupId from "@/views/procurement-management/parent-account-code-groups/id.vue";
//Parent Account Codes
import ParentAccountCodes from "@/views/procurement-management/parent-account-codes/index.vue";
import ParentAccountCodeCreate from "@/views/procurement-management/parent-account-codes/create.vue";
import ParentAccountCodeId from "@/views/procurement-management/parent-account-codes/id.vue";
//Company Account Codes
import CompanyAccountCodes from "@/views/procurement-management/company-account-codes/index.vue";
import CompanyAccountCodeCreate from "@/views/procurement-management/company-account-codes/create.vue";
import CompanyAccountCodeId from "@/views/procurement-management/company-account-codes/id.vue";
//Owner Account Codes
import OwnerAccountCodes from "@/views/procurement-management/owner-account-codes/index.vue";
import OwnerAccountCodeCreate from "@/views/procurement-management/owner-account-codes/create.vue";
import OwnerAccountCodeId from "@/views/procurement-management/owner-account-codes/id.vue";
//Po Term Condition
import PoTermConditions from "@/views/procurement-management/po-term-conditions/index.vue";
import PoTermConditionCreate from "@/views/procurement-management/po-term-conditions/create.vue";
import PoTermConditionId from "@/views/procurement-management/po-term-conditions/id.vue";
//Supplier Details
import SupplierDetails from "@/views/procurement-management/supplier-details/index.vue";
import SupplierDetailCreate from "@/views/procurement-management/supplier-details/create.vue";
import SupplierDetailId from "@/views/procurement-management/supplier-details/id.vue";
//Approval Limits
import ApprovalLimits from "@/views/procurement-management/approval-limits/index.vue";
import ApprovalLimitCreate from "@/views/procurement-management/approval-limits/create.vue";
import ApprovalLimitId from "@/views/procurement-management/approval-limits/id.vue";
//Account Code
import AccountCodes from "@/views/procurement-management/account-codes/index.vue";
import AccountCodeCreate from "@/views/procurement-management/account-codes/create.vue";
import AccountCodeId from "@/views/procurement-management/account-codes/id.vue";
//Owner Account Mappings
import OwnerAccountMappings from "@/views/procurement-management/owner-account-mappings/index.vue";
import OwnerAccountMappingCreate from "@/views/procurement-management/owner-account-mappings/create.vue";
import OwnerAccountMappingId from "@/views/procurement-management/owner-account-mappings/id.vue";
//Taxes Setup
import TaxSetups from "@/views/procurement-management/tax-setups/index.vue";
import TaxSetupCreate from "@/views/procurement-management/tax-setups/create.vue";
import TaxSetupId from "@/views/procurement-management/tax-setups/id.vue";
// Data Module
// Requisition
import Requisitions from "@/views/procurement-management/requisitions/index.vue";
import RequisitionCreate from "@/views/procurement-management/requisitions/create.vue";
import RequisitionId from "@/views/procurement-management/requisitions/id.vue";
// RFQ
import Rfqs from "@/views/procurement-management/rfqs/index.vue";
import RfqCreate from "@/views/procurement-management/rfqs/create.vue";
import RfqId from "@/views/procurement-management/rfqs/id.vue";
// Quotation
import Quotations from "@/views/procurement-management/quotations/index.vue";
import QuotationCreate from "@/views/procurement-management/quotations/create.vue";
import QuotationId from "@/views/procurement-management/quotations/id.vue";
// Purchase Order
import PurchaseOrders from "@/views/procurement-management/purchase-orders/index.vue";
import PurchaseOrderCreate from "@/views/procurement-management/purchase-orders/create.vue";
import PurchaseOrderId from "@/views/procurement-management/purchase-orders/id.vue";
// Invoice
import Invoices from "@/views/procurement-management/invoices/index.vue";
import InvoiceCreate from "@/views/procurement-management/invoices/create.vue";
import InvoiceId from "@/views/procurement-management/invoices/id.vue";

// Charterer Categories (Voayge Monitoring)
// Charterer
import Charterers from "@/views/voyage-monitoring/charterers/index.vue";
// Directions
import Directions from "@/views/voyage-monitoring/directions/index.vue";
// Fuel Consumption List
import FuelConsumptionLists from "@/views/voyage-monitoring/fuel-consumption-lists/index.vue";
// Running Hours List
import RunningHoursLists from "@/views/voyage-monitoring/running-hours-lists/index.vue";
// Consumption Types
import ConsumptionTypes from "@/views/voyage-monitoring/consumption-types/index.vue";
import ConsumptionTypeCreate from "@/views/voyage-monitoring/consumption-types/create.vue";
import ConsumptionTypeId from "@/views/voyage-monitoring/consumption-types/id.vue";

// Rest Hour Categories
// Charterer
import HolidaysAndFixedWorkingHours from "@/views/rest-management/holidays-and-fixed-working-hours/index.vue";
// Directions
import Operations from "@/views/rest-management/operations/index.vue";
// Rest Hour Settings
import RestHourSettings from "@/views/rest-management/rest-hour-settings/index.vue";
import RestHourSettingCreate from "@/views/rest-management/rest-hour-settings/create.vue";
import RestHourSettingId from "@/views/rest-management/rest-hour-settings/id.vue";
// Crew Details
import CrewDetails from "@/views/rest-management/crew-details/index.vue";
import CrewDetailCreate from "@/views/rest-management/crew-details/create.vue";
import CrewDetailId from "@/views/rest-management/crew-details/id.vue";
// Vessel Holiday calenders
import VesselHolidayCalendars from "@/views/rest-management/vessel-holiday-calenders/index.vue";
import VesselHolidayCalendarCreate from "@/views/rest-management/vessel-holiday-calenders/create.vue";
import VesselHolidayCalendarId from "@/views/rest-management/vessel-holiday-calenders/id.vue";

// Planned Maintenance
// Main Machinery Groups
import MainMachineryGroups from "@/views/planned-maintenance/main-machinery-groups/index.vue";
// General Item / Inventory category
import GeneralItemInventoryCategories from "@/views/planned-maintenance/general-item-inventory-categories/index.vue";
// Locations on Board
import LocationOnBoard from "@/views/planned-maintenance/locations-and-board/index.vue";
// Job Categories
import JobCategories from "@/views/planned-maintenance/job-categories/index.vue";
// Class Survey Groups
import ClassSurveyGroups from "@/views/planned-maintenance/class-survey-groups/index.vue";
// Vessel Certificate Names
import PMVesselCertificateNames from "@/views/planned-maintenance/vessel-certificate-names/index.vue";
// Vessel Certificate Category
import PMVesselCertificateCategories from "@/views/planned-maintenance/vessel-certificate-categories/index.vue";
// Defect category
import DefectCategories from "@/views/planned-maintenance/defect-categores/index.vue";
// Inspection Groups
import InspectionGroups from "@/views/planned-maintenance/inspection-groups/index.vue";
// Inspection Types
import InspectionTypes from "@/views/planned-maintenance/inspection-types/index.vue";
// Postponement Reason
import PostponementReasons from "@/views/planned-maintenance/postponement-reasons/index.vue";
// Reasons for pending
import ReasonsForPendings from "@/views/planned-maintenance/reasons-for-pendings/index.vue";
// Vessel Deficiency Root Cause
import VesselDeficiencyRootCauses from "@/views/planned-maintenance/vessel-deficiency-root-causes/index.vue";
// Machinary details
import MachinaryDetails from "@/views/planned-maintenance/machinary-details/index.vue";
import MachinaryDetailCreate from "@/views/planned-maintenance/machinary-details/create.vue";
import MachinaryDetailId from "@/views/planned-maintenance/machinary-details/id.vue";
//Spare Parts
import SpareParts from "@/views/planned-maintenance/spare-parts/index.vue";
import SparePartCreate from "@/views/planned-maintenance/spare-parts/create.vue";
import SparePartId from "@/views/planned-maintenance/spare-parts/id.vue";
//General Items / Inventory
import GeneralItemInventories from "@/views/planned-maintenance/general-item-inventories/index.vue";
import GeneralItemInventoryCreate from "@/views/planned-maintenance/general-item-inventories/create.vue";
import GeneralItemInventoryId from "@/views/planned-maintenance/general-item-inventories/id.vue";
//Inspection Conditions
import InspectionConditions from "@/views/planned-maintenance/inspection-conditions/index.vue";
import InspectionConditionCreate from "@/views/planned-maintenance/inspection-conditions/create.vue";
import InspectionConditionId from "@/views/planned-maintenance/inspection-conditions/id.vue";
//Miscellaneous items
import MiscellaneousItems from "@/views/planned-maintenance/miscellaneous-items/index.vue";
import MiscellaneousItemCreate from "@/views/planned-maintenance/miscellaneous-items/create.vue";
import MiscellaneousItemId from "@/views/planned-maintenance/miscellaneous-items/id.vue";

// Perameter Setup
import ParameterSetups from "@/views/planned-maintenance/parameter-setups/index.vue";
import ParameterSetupCreate from "@/views/planned-maintenance/parameter-setups/create.vue";
import ParameterSetupId from "@/views/planned-maintenance/parameter-setups/id.vue";

// Perameter Monitoring
import ParameterMonitorings from "@/views/planned-maintenance/parameter-monitorings/index.vue";
import ParameterMonitoringCreate from "@/views/planned-maintenance/parameter-monitorings/create.vue";
import ParameterMonitoringId from "@/views/planned-maintenance/parameter-monitorings/id.vue";

// Perameter Monitoring
import OfficeJobSchedulers from "@/views/planned-maintenance/office-job-schedulers/index.vue";
import OfficeJobSchedulerCreate from "@/views/planned-maintenance/office-job-schedulers/create.vue";
import OfficeJobSchedulerId from "@/views/planned-maintenance/office-job-schedulers/id.vue";

// Class Recommendation And Notes
import ClassRecommendationAndNotes from "@/views/planned-maintenance/class-recommendation-and-notes/index.vue";
import ClassRecommendationAndNoteCreate from "@/views/planned-maintenance/class-recommendation-and-notes/create.vue";
import ClassRecommendationAndNoteId from "@/views/planned-maintenance/class-recommendation-and-notes/id.vue";

// Vessel Certificate
import VesselCertificates from "@/views/planned-maintenance/vessel-certificates/index.vue";
import VesselCertificateCreate from "@/views/planned-maintenance/vessel-certificates/create.vue";
import VesselCertificateId from "@/views/planned-maintenance/vessel-certificates/id.vue";
// Document Management
// Categories
import DMCategories from "@/views/document-management/categories/index.vue";

//New Document
import NewDocuments from "@/views/document-management/documents/index.vue";
import NewDocumentCreate from "@/views/document-management/documents/create.vue";
import NewDocumentId from "@/views/document-management/documents/id.vue";

// Form Management
// Categories
import FMCategories from "@/views/form-management/categories/index.vue";
// Form
import Forms from "@/views/form-management/forms/index.vue";
import FormCreate from "@/views/form-management/forms/create.vue";
import FormId from "@/views/form-management/forms/id.vue";

// Environmanet Management
// Financial Year Quarters
import FinancialYearQuarters from "@/views/environment-management/financial-year-quarters/index.vue";
import FinancialYearQuarterCreate from "@/views/environment-management/financial-year-quarters/create.vue";
import FinancialYearQuarterId from "@/views/environment-management/financial-year-quarters/id.vue";

// System Setup
//Organizations
import Organizations from "@/views/system-setup/organizations/index.vue";
import OrganizationCreate from "@/views/system-setup/organizations/create.vue";
import OrganizationId from "@/views/system-setup/organizations/id.vue";

//Owners
import Owners from "@/views/system-setup/owners/index.vue";
import OwnerCreate from "@/views/system-setup/owners/create.vue";
import OwnerId from "@/views/system-setup/owners/id.vue";

//Vessels
import Vessels from "@/views/system-setup/vessels/index.vue";
import VesselCreate from "@/views/system-setup/vessels/create.vue";
import VesselId from "@/views/system-setup/vessels/id.vue";

//Units
import Units from "@/views/system-setup/units/index.vue";
import UnitCreate from "@/views/system-setup/units/create.vue";
import UnitId from "@/views/system-setup/units/id.vue";

//Ports
import Ports from "@/views/system-setup/ports/index.vue";
import PortCreate from "@/views/system-setup/ports/create.vue";
import PortId from "@/views/system-setup/ports/id.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    component: AuthLayout,
    children: [
      {
        path: "/",
        name: "Home",
        component: Home,
      },
      // Values
      {
        path: "/values",
        name: "Values",
        component: Values,
      },
      // {
      //   path: "/values/upload",
      //   name: "ValuesUpload",
      //   component: ValuesUpload,
      // },
      {
        path: "/values/create",
        name: "ValueCreate",
        component: ValueCreate,
      },
      {
        path: "/values/:valueId",
        name: "ValueId",
        component: ValueId,
      },
      // ValueLists
      {
        path: "/value-lists",
        name: "ValueLists",
        component: ValueLists,
      },
      // {
      //   path: "/value-lists/upload",
      //   name: "ValueListUpload",
      //   component: ValueListUpload,
      // },
      {
        path: "/value-lists/create",
        name: "ValueListCreate",
        component: ValueListCreate,
      },
      {
        path: "/value-lists/:valueListId",
        name: "ValueListId",
        component: ValueListId,
      },
      // ValueListDetails
      {
        path: "/value-list-details",
        name: "ValueListDetails",
        component: ValueListDetails,
      },
      // {
      //   path: "/value-list-details/upload",
      //   name: "ValueListDetailUpload",
      //   component: ValueListDetailUpload,
      // },
      {
        path: "/value-list-details/create",
        name: "ValueListDetailCreate",
        component: ValueListDetailCreate,
      },
      {
        path: "/value-list-details/:valueListId",
        name: "ValueListDetailId",
        component: ValueListDetailId,
      },
      // Report Types
      {
        path: "/safety-management/report-types",
        name: "ReportTypes",
        component: ReportTypes,
      },
      // Accident Types
      {
        path: "/safety-management/accident-types",
        name: "AccidentTypes",
        component: AccidentTypes,
      },
      // Accident Root Cause Types
      {
        path: "/safety-management/accident-root-cause-types",
        name: "AccidentRootCauseTypes",
        component: AccidentRootCauseTypes,
      },
      // Accident Prevention Action Categories
      {
        path: "/safety-management/accident-preventive-action-categories",
        name: "AccidentPreventiveActionCategories",
        component: AccidentPreventiveActionCategories,
      },
      // Near Miss Categories
      {
        path: "/safety-management/near-miss-categories",
        name: "NearMssCategories",
        component: NearMssCategories,
      },
      // Audit Types
      {
        path: "/safety-management/audit-types",
        name: "AuditTypes",
        component: AuditTypes,
      },
      // Audit Type Details
      {
        path: "/safety-management/audit-types/:auditId",
        name: "AuditTypeDetails",
        component: AuditTypeDetails,
      },
      // Internal Audit Types
      {
        path: "/safety-management/internal-audit-types",
        name: "InternalAuditTypes",
        component: InternalAuditTypes,
      },
      // Audit category
      {
        path: "/safety-management/audit-categories",
        name: "AuditCategories",
        component: AuditCategories,
      },
      // Drill Categories
      {
        path: "/safety-management/drill-categories",
        name: "DrillCategories",
        component: DrillCategories,
      },
      // Basis of CAR
      {
        path: "/safety-management/basis-of-car",
        name: "BasisOfCar",
        component: BasisOfCar,
      },
      // Emergency Company Types
      {
        path: "/safety-management/emergency-company-types",
        name: "EmergencyCompanyTypes",
        component: EmergencyCompanyTypes,
      },
      // Master Handing/Taking Over Checklist
      {
        path: "/safety-management/master-handing-taking-over-checklist",
        name: "MasterHandingTakingOverChecklist",
        component: MasterHandingTakingOverChecklist,
      },
      // Officer & Engineer Handing/Taking Over Checklist
      {
        path: "/safety-management/officer-enginner-handing-taking-over-checklist",
        name: "OffcerEngineerHandingTakingOverChecklist",
        component: OffcerEngineerHandingTakingOverChecklist,
      },
      // Safety Meeting Agenda
      {
        path: "/safety-management/safety-meeting-agendas",
        name: "SafetyMeetingAgenda",
        component: SafetyMeetingAgenda,
      },
      // Masters Management Agenda
      {
        path: "/safety-management/masters-management-agendas",
        name: "MastersManagementAgenda",
        component: MastersManagementAgenda,
      },
      // Locations on Board
      {
        path: "/safety-management/locations-on-board",
        name: "LocationsOfBoard",
        component: LocationsOfBoard,
      },
      // VIQ Number
      {
        path: "/safety-management/viq-numbers",
        name: "VIQNumber",
        component: VIQNumber,
      },
      // Type of operation
      {
        path: "/safety-management/types-of-operations",
        name: "TypesOfOperation",
        component: TypesOfOperation,
      },
      // Type of Training
      {
        path: "/safety-management/types-of-trainings",
        name: "TypesOfTraining",
        component: TypesOfTraining,
      },
      // Potential Incident Category
      {
        path: "/safety-management/potential-incident-categories",
        name: "PotentialIncidentCategories",
        component: PotentialIncidentCategories,
      },
      // Type of injury
      {
        path: "/safety-management/type-of-injuries",
        name: "TypeOfInjury",
        component: TypeOfInjury,
      },
      // Company / Service Line
      {
        path: "/safety-management/company-service-lines",
        name: "CompanyServiceLine",
        component: CompanyServiceLine,
      },
      // Category Oceaneering - Cards
      {
        path: "/safety-management/category-oceaneering-cards",
        name: "CategoryOceaneeringCards",
        component: CategoryOceaneeringCards,
      },
      // High Hazard Task Observation
      {
        path: "/safety-management/high-hazard-task-observations",
        name: "HighHazardTaskObservation",
        component: HighHazardTaskObservation,
      },
      // Observation Category
      {
        path: "/safety-management/observation-categories",
        name: "ObservationCategories",
        component: ObservationCategories,
      },
      // Evaluation Types
      {
        path: "/safety-management/evalution-types",
        name: "EvalutionTypes",
        component: EvalutionTypes,
      },
      // Syllabus for Training Evaluation
      {
        path: "/safety-management/syllabus-for-training-evalutions",
        name: "SyllabusForTrainingEvalution",
        component: SyllabusForTrainingEvalution,
      },
      // NC Category
      {
        path: "/safety-management/nc-categories",
        name: "NCCategories",
        component: NCCategories,
      },
      // MNC Category
      {
        path: "/safety-management/mnc-categories",
        name: "MNCCategories",
        component: MNCCategories,
      },
      // Injury Category
      {
        path: "/safety-management/injury-categories",
        name: "InjuryCategories",
        component: InjuryCategories,
      },
      // Observation Category
      {
        path: "/safety-management/main-observation-categories",
        name: "MainObservationCategories",
        component: MainObservationCategories,
      },
      // Vessel Certificate Category
      {
        path: "/safety-management/vessel-certificate-categories",
        name: "VesselCertificateCategories",
        component: VesselCertificateCategories,
      },
      // Vessel Certificate Names
      {
        path: "/safety-management/vessel-certificate-names",
        name: "VesselCertificateNames",
        component: VesselCertificateNames,
      },
      // Procurement Management
      //Supplier Types
      {
        path: "/procurement-management/supplier-types",
        name: "SupplierTypes",
        component: SupplierTypes,
      },
      //Requisition nature
      {
        path: "/procurement-management/requisition-natures",
        name: "RequisitionNatures",
        component: RequisitionNatures,
      },
      //Invoice Discrepancy Reason
      {
        path: "/procurement-management/invoice-discrepancy-reasons",
        name: "InvoiceDiscrepancyReasons",
        component: InvoiceDiscrepancyReasons,
      },
      //Expenses category
      {
        path: "/procurement-management/expenses-categories",
        name: "ExpensesCategories",
        component: ExpensesCategories,
      },
      // Buyers
      {
        path: "/procurement-management/buyers",
        name: "Buyers",
        component: Buyers,
      },
      {
        path: "/procurement-management/buyers/create",
        name: "BuyerCreate",
        component: BuyerCreate,
      },
      {
        path: "/procurement-management/buyers/:buyerId",
        name: "BuyerId",
        component: BuyerId,
      },
      // Parent Account Code Groups
      {
        path: "/procurement-management/parent-account-code-groups",
        name: "ParentAccountCodeGroups",
        component: ParentAccountCodeGroups,
      },
      {
        path: "/procurement-management/parent-account-code-groups/create",
        name: "ParentAccountCodeGroupCreate",
        component: ParentAccountCodeGroupCreate,
      },
      {
        path: "/procurement-management/parent-account-code-groups/:pacgId",
        name: "ParentAccountCodeGroupId",
        component: ParentAccountCodeGroupId,
      },
      // Parent Account Codes
      {
        path: "/procurement-management/parent-account-codes",
        name: "ParentAccountCodes",
        component: ParentAccountCodes,
      },
      {
        path: "/procurement-management/parent-account-codes/create",
        name: "ParentAccountCodeCreate",
        component: ParentAccountCodeCreate,
      },
      {
        path: "/procurement-management/parent-account-codes/:pacId",
        name: "ParentAccountCodeId",
        component: ParentAccountCodeId,
      },
      // Company Account Codes
      {
        path: "/procurement-management/company-account-codes",
        name: "CompanyAccountCodes",
        component: CompanyAccountCodes,
      },
      {
        path: "/procurement-management/company-account-codes/create",
        name: "CompanyAccountCodeCreate",
        component: CompanyAccountCodeCreate,
      },
      {
        path: "/procurement-management/company-account-codes/:cacId",
        name: "CompanyAccountCodeId",
        component: CompanyAccountCodeId,
      },
      // Owner Account Codes
      {
        path: "/procurement-management/owner-account-codes",
        name: "OwnerAccountCodes",
        component: OwnerAccountCodes,
      },
      {
        path: "/procurement-management/owner-account-codes/create",
        name: "OwnerAccountCodeCreate",
        component: OwnerAccountCodeCreate,
      },
      {
        path: "/procurement-management/owner-account-codes/:oacId",
        name: "OwnerAccountCodeId",
        component: OwnerAccountCodeId,
      },
      // Po Term And Condition
      {
        path: "/procurement-management/po-term-conditions",
        name: "PoTermConditions",
        component: PoTermConditions,
      },
      {
        path: "/procurement-management/po-term-conditions/create",
        name: "PoTermConditionCreate",
        component: PoTermConditionCreate,
      },
      {
        path: "/procurement-management/po-term-conditions/:oacId",
        name: "PoTermConditionId",
        component: PoTermConditionId,
      },
      // Supplier Detail
      {
        path: "/procurement-management/supplier-details",
        name: "SupplierDetails",
        component: SupplierDetails,
      },
      {
        path: "/procurement-management/supplier-details/create",
        name: "SupplierDetailCreate",
        component: SupplierDetailCreate,
      },
      {
        path: "/procurement-management/supplier-details/:supplier_detail_Id",
        name: "SupplierDetailId",
        component: SupplierDetailId,
      },
      // Approval Limit
      {
        path: "/procurement-management/approval-limits",
        name: "ApprovalLimits",
        component: ApprovalLimits,
      },
      {
        path: "/procurement-management/approval-limits/create",
        name: "ApprovalLimitCreate",
        component: ApprovalLimitCreate,
      },
      {
        path: "/procurement-management/approval-limits/:approval_limit_Id",
        name: "ApprovalLimitId",
        component: ApprovalLimitId,
      },
      // Account Code
      {
        path: "/procurement-management/account-codes",
        name: "AccountCodes",
        component: AccountCodes,
      },
      {
        path: "/procurement-management/account-codes/create",
        name: "AccountCodeCreate",
        component: AccountCodeCreate,
      },
      {
        path: "/procurement-management/account-codes/:account_code_Id",
        name: "AccountCodeId",
        component: AccountCodeId,
      },
      // Owner Account Mappings
      {
        path: "/procurement-management/owner-account-mappings",
        name: "OwnerAccountMappings",
        component: OwnerAccountMappings,
      },
      {
        path: "/procurement-management/owner-account-mappings/create",
        name: "OwnerAccountMappingCreate",
        component: OwnerAccountMappingCreate,
      },
      {
        path: "/procurement-management/owner-account-mappings/:owner_account_mapping_Id",
        name: "OwnerAccountMappingId",
        component: OwnerAccountMappingId,
      },
      // Taxes Setup
      {
        path: "/procurement-management/tax-setups",
        name: "TaxSetups",
        component: TaxSetups,
      },
      {
        path: "/procurement-management/tax-setups/create",
        name: "TaxSetupCreate",
        component: TaxSetupCreate,
      },
      {
        path: "/procurement-management/tax-setups/:tax_setup_Id",
        name: "TaxSetupId",
        component: TaxSetupId,
      },
      // Data Module
      // Requisition
      {
        path: "/procurement-management/requisitions",
        name: "Requisitions",
        component: Requisitions,
      },
      {
        path: "/procurement-management/requisitions/create",
        name: "RequisitionCreate",
        component: RequisitionCreate,
      },
      {
        path: "/procurement-management/requisitions/:requisitionId",
        name: "RequisitionId",
        component: RequisitionId,
      },
      // RFQ
      {
        path: "/procurement-management/rfqs",
        name: "Rfqs",
        component: Rfqs,
      },
      {
        path: "/procurement-management/rfqs/create",
        name: "RfqCreate",
        component: RfqCreate,
      },
      {
        path: "/procurement-management/rfqs/:rfqId",
        name: "RfqId",
        component: RfqId,
      },
      // Quotation
      {
        path: "/procurement-management/quotations",
        name: "Quotations",
        component: Quotations,
      },
      {
        path: "/procurement-management/quotations/create",
        name: "QuotationCreate",
        component: QuotationCreate,
      },
      {
        path: "/procurement-management/quotations/:quotationId",
        name: "QuotationId",
        component: QuotationId,
      },
      // Purchase Order
      {
        path: "/procurement-management/purchase-orders",
        name: "PurchaseOrders",
        component: PurchaseOrders,
      },
      {
        path: "/procurement-management/purchase-orders/create",
        name: "PurchaseOrderCreate",
        component: PurchaseOrderCreate,
      },
      {
        path: "/procurement-management/purchase-orders/:purchaseId",
        name: "PurchaseOrderId",
        component: PurchaseOrderId,
      },
      // Invoice
      {
        path: "/procurement-management/invoices",
        name: "Invoices",
        component: Invoices,
      },
      {
        path: "/procurement-management/invoices/create",
        name: "InvoiceCreate",
        component: InvoiceCreate,
      },
      {
        path: "/procurement-management/invoices/:invoiceId",
        name: "InvoiceId",
        component: InvoiceId,
      },
      //Charterer Management (Voayge Monitoring)
      // Charterer
      {
        path: "/voyage-monitoring/charterer",
        name: "Charterers",
        component: Charterers,
      },
      // Directions
      {
        path: "/voyage-monitoring/directions",
        name: "Directions",
        component: Directions,
      },
      // Fuel Consumption List
      {
        path: "/voyage-monitoring/fuel-consumption-lists",
        name: "FuelConsumptionLists",
        component: FuelConsumptionLists,
      },
      // Running Hours List
      {
        path: "/voyage-monitoring/running-hours-lists",
        name: "RunningHoursLists",
        component: RunningHoursLists,
      },
      //Consumption Types
      {
        path: "/voyage-monitoring/consumption-types",
        name: "ConsumptionTypes",
        component: ConsumptionTypes,
      },
      {
        path: "/voyage-monitoring/consumption-types/create",
        name: "ConsumptionTypeCreate",
        component: ConsumptionTypeCreate,
      },
      {
        path: "/voyage-monitoring/consumption-types/:ctId",
        name: "ConsumptionTypeId",
        component: ConsumptionTypeId,
      },
      //Rest Hours Management
      // Holidays and Fixed Working Hours
      {
        path: "/rest-hours-management/holidays-and-fixed-working-hours",
        name: "HolidaysAndFixedWorkingHours",
        component: HolidaysAndFixedWorkingHours,
      },
      // Operations
      {
        path: "/rest-hours-management/operations",
        name: "Operations",
        component: Operations,
      },
      // Rest Hour Settings
      {
        path: "/rest-hours-management/rest-hour-settings",
        name: "RestHourSettings",
        component: RestHourSettings,
      },
      {
        path: "/rest-hours-management/rest-hour-settings/create",
        name: "RestHourSettingCreate",
        component: RestHourSettingCreate,
      },
      {
        path: "/rest-hours-management/rest-hour-settings/:rest_hour_setting_Id",
        name: "RestHourSettingId",
        component: RestHourSettingId,
      },
      // Crew Details
      {
        path: "/rest-hours-management/crew-details",
        name: "CrewDetails",
        component: CrewDetails,
      },
      {
        path: "/rest-hours-management/crew-details/create",
        name: "CrewDetailCreate",
        component: CrewDetailCreate,
      },
      {
        path: "/rest-hours-management/crew-details/:crew_Id",
        name: "CrewDetailId",
        component: CrewDetailId,
      },
      // Vessel Holiday Calenders
      {
        path: "/rest-hours-management/vessel-holiday-calendars",
        name: "VesselHolidayCalendars",
        component: VesselHolidayCalendars,
      },
      {
        path: "/rest-hours-management/vessel-holiday-calendars/create",
        name: "VesselHolidayCalendarCreate",
        component: VesselHolidayCalendarCreate,
      },
      {
        path: "/rest-hours-management/vessel-holiday-calendars/:vessel_holiday_calendar_Id",
        name: "VesselHolidayCalendarId",
        component: VesselHolidayCalendarId,
      },
      //Planned Maintenance
      // Main Machinery Groups
      {
        path: "/planned-maintenance/main-machinery-groups",
        name: "MainMachineryGroups",
        component: MainMachineryGroups,
      },
      // General Item / Inventory category
      {
        path: "/planned-maintenance/general-item-inventory-categories",
        name: "GeneralItemInventoryCategories",
        component: GeneralItemInventoryCategories,
      },
      // Locations on Board
      {
        path: "/planned-maintenance/location-on-boards",
        name: "LocationOnBoard",
        component: LocationOnBoard,
      },
      // Job Categories
      {
        path: "/planned-maintenance/job-categories",
        name: "JobCategories",
        component: JobCategories,
      },
      // Class Survey Groups
      {
        path: "/planned-maintenance/class-survey-groups",
        name: "ClassSurveyGroups",
        component: ClassSurveyGroups,
      },
      // Vessel Certificate Names
      {
        path: "/planned-maintenance/vessel-certificate-names",
        name: "PMVesselCertificateNames",
        component: PMVesselCertificateNames,
      },
      // Vessel Certificate Category
      {
        path: "/planned-maintenance/vessel-certificate-categories",
        name: "PMVesselCertificateCategories",
        component: PMVesselCertificateCategories,
      },
      // Defect category
      {
        path: "/planned-maintenance/defect-categories",
        name: "DefectCategories",
        component: DefectCategories,
      },
      // Inspection Groups
      {
        path: "/planned-maintenance/inspection-groups",
        name: "InspectionGroups",
        component: InspectionGroups,
      },
      // Inspection Types
      {
        path: "/planned-maintenance/inspection-types",
        name: "InspectionTypes",
        component: InspectionTypes,
      },
      // Postponement Reason
      {
        path: "/planned-maintenance/postponement-reasons",
        name: "PostponementReasons",
        component: PostponementReasons,
      },
      // Reasons for pending
      {
        path: "/planned-maintenance/reasons-for-pending",
        name: "ReasonsForPendings",
        component: ReasonsForPendings,
      },
      // Vessel Deficiency Root Cause
      {
        path: "/planned-maintenance/vessel-deficiency-root-causes",
        name: "VesselDeficiencyRootCauses",
        component: VesselDeficiencyRootCauses,
      },
      // Machinery Details
      {
        path: "/planned-maintenance/machinary-details",
        name: "MachinaryDetails",
        component: MachinaryDetails,
      },
      {
        path: "/planned-maintenance/machinary-details/create",
        name: "MachinaryDetailCreate",
        component: MachinaryDetailCreate,
      },
      {
        path: "/planned-maintenance/machinary-details/:machinary_detail_Id",
        name: "MachinaryDetailId",
        component: MachinaryDetailId,
      },
      //Spare Parts
      {
        path: "/planned-maintenance/spare-parts",
        name: "SpareParts",
        component: SpareParts,
      },
      {
        path: "/planned-maintenance/spare-parts/create",
        name: "SparePartCreate",
        component: SparePartCreate,
      },
      {
        path: "/planned-maintenance/spare-parts/:spare_part_Id",
        name: "SparePartId",
        component: SparePartId,
      },
      // General Items / Inventory
      {
        path: "/planned-maintenance/general-item-inventories",
        name: "GeneralItemInventories",
        component: GeneralItemInventories,
      },
      {
        path: "/planned-maintenance/general-item-inventories/create",
        name: "GeneralItemInventoryCreate",
        component: GeneralItemInventoryCreate,
      },
      {
        path: "/planned-maintenance/general-item-inventories/:general_item_inventory_Id",
        name: "GeneralItemInventoryId",
        component: GeneralItemInventoryId,
      },
      // Inspection Conditions
      {
        path: "/planned-maintenance/inspection-conditions",
        name: "InspectionConditions",
        component: InspectionConditions,
      },
      {
        path: "/planned-maintenance/inspection-conditions/create",
        name: "InspectionConditionCreate",
        component: InspectionConditionCreate,
      },
      {
        path: "/planned-maintenance/inspection-conditions/:inspection_condition_Id",
        name: "InspectionConditionId",
        component: InspectionConditionId,
      },
      // Miscellaneous items
      {
        path: "/planned-maintenance/miscellaneous-items",
        name: "MiscellaneousItems",
        component: MiscellaneousItems,
      },
      {
        path: "/planned-maintenance/miscellaneous-items/create",
        name: "MiscellaneousItemCreate",
        component: MiscellaneousItemCreate,
      },
      {
        path: "/planned-maintenance/miscellaneous-items/:miscellaneous_item_Id",
        name: "MiscellaneousItemId",
        component: MiscellaneousItemId,
      },
      // Data Setup
      // Perameter Setup
      {
        path: "/planned-maintenance/parameter-setups",
        name: "ParameterSetups",
        component: ParameterSetups,
      },
      {
        path: "/planned-maintenance/parameter-setups/create",
        name: "ParameterSetupCreate",
        component: ParameterSetupCreate,
      },
      {
        path: "/planned-maintenance/parameter-setups/:parameterSetupId",
        name: "ParameterSetupId",
        component: ParameterSetupId,
      },
      // Perameter Monitoring
      {
        path: "/planned-maintenance/parameter-monitorings",
        name: "ParameterMonitorings",
        component: ParameterMonitorings,
      },
      {
        path: "/planned-maintenance/parameter-monitorings/create",
        name: "ParameterMonitoringCreate",
        component: ParameterMonitoringCreate,
      },
      {
        path: "/planned-maintenance/parameter-monitorings/:parameterMonitoringId",
        name: "ParameterMonitoringId",
        component: ParameterMonitoringId,
      },
      // Office Job Schedulers
      {
        path: "/planned-maintenance/office-job-schedulers",
        name: "OfficeJobSchedulers",
        component: OfficeJobSchedulers,
      },
      {
        path: "/planned-maintenance/office-job-schedulers/create",
        name: "OfficeJobSchedulerCreate",
        component: OfficeJobSchedulerCreate,
      },
      {
        path: "/planned-maintenance/office-job-schedulers/:ofsId",
        name: "OfficeJobSchedulerId",
        component: OfficeJobSchedulerId,
      },
      // Class Recommendation and Notes
      {
        path: "/planned-maintenance/class-recommendation-and-notes",
        name: "ClassRecommendationAndNotes",
        component: ClassRecommendationAndNotes,
      },
      {
        path: "/planned-maintenance/class-recommendation-and-notes/create",
        name: "ClassRecommendationAndNoteCreate",
        component: ClassRecommendationAndNoteCreate,
      },
      {
        path: "/planned-maintenance/class-recommendation-and-notes/:cranId",
        name: "ClassRecommendationAndNoteId",
        component: ClassRecommendationAndNoteId,
      },
      // Vessel Certificate
      {
        path: "/planned-maintenance/vessel-certificates",
        name: "VesselCertificates",
        component: VesselCertificates,
      },
      {
        path: "/planned-maintenance/vessel-certificates/create",
        name: "VesselCertificateCreate",
        component: VesselCertificateCreate,
      },
      {
        path: "/planned-maintenance/vessel-certificates/:vesselCertificateId",
        name: "VesselCertificateId",
        component: VesselCertificateId,
      },
      // Document Management
      // Setup Module
      // categories
      {
        path: "/document-management/categories",
        name: "DMCategories",
        component: DMCategories,
      },
      // Data Module
      // New Document
      {
        path: "/document-management/new-documents",
        name: "NewDocuments",
        component: NewDocuments,
      },
      {
        path: "/document-management/new-documents/create",
        name: "NewDocumentCreate",
        component: NewDocumentCreate,
      },
      {
        path: "/document-management/new-documents/:documentId",
        name: "NewDocumentId",
        component: NewDocumentId,
      },
      // Form Management
      // categories
      {
        path: "/form-management/categories",
        name: "FMCategories",
        component: FMCategories,
      },
      // Form Data
      // Form
      {
        path: "/form-management/forms",
        name: "Forms",
        component: Forms,
      },
      {
        path: "/form-management/forms/create",
        name: "FormCreate",
        component: FormCreate,
      },
      {
        path: "/form-management/forms/:formId",
        name: "FormId",
        component: FormId,
      },
      // Environment Management
      // Financial Year Quarters
      {
        path: "/environment-management/financial-year-quarters",
        name: "FinancialYearQuarters",
        component: FinancialYearQuarters,
      },
      {
        path: "/environment-management/financial-year-quarters/create",
        name: "FinancialYearQuarterCreate",
        component: FinancialYearQuarterCreate,
      },
      {
        path: "/environment-management/financial-year-quarters/:financial_year_quarter_Id",
        name: "FinancialYearQuarterId",
        component: FinancialYearQuarterId,
      },
      // System Setup
      // Organization
      {
        path: "/system-setup/organizations",
        name: "Organizations",
        component: Organizations,
      },
      {
        path: "/system-setup/organizations/create",
        name: "OrganizationCreate",
        component: OrganizationCreate,
      },
      {
        path: "/system-setup/organizations/:organizationId",
        name: "OrganizationId",
        component: OrganizationId,
      },
      // Owner
      {
        path: "/system-setup/owners",
        name: "Owners",
        component: Owners,
      },
      {
        path: "/system-setup/owners/create",
        name: "OwnerCreate",
        component: OwnerCreate,
      },
      {
        path: "/system-setup/owners/:ownerId",
        name: "OwnerId",
        component: OwnerId,
      },
      // Vessel
      {
        path: "/system-setup/vessels",
        name: "Vessels",
        component: Vessels,
      },
      {
        path: "/system-setup/vessels/create",
        name: "VesselCreate",
        component: VesselCreate,
      },
      {
        path: "/system-setup/vessels/:vesselId",
        name: "VesselId",
        component: VesselId,
      },
      // Unit
      {
        path: "/system-setup/units",
        name: "Units",
        component: Units,
      },
      {
        path: "/system-setup/units/create",
        name: "UnitCreate",
        component: UnitCreate,
      },
      {
        path: "/system-setup/units/:unitId",
        name: "UnitId",
        component: UnitId,
      },
      // Port
      {
        path: "/system-setup/ports",
        name: "Ports",
        component: Ports,
      },
      {
        path: "/system-setup/ports/create",
        name: "PortCreate",
        component: PortCreate,
      },
      {
        path: "/system-setup/ports/:portId",
        name: "PortId",
        component: PortId,
      },
    ],
  },
  {
    path: "",
    name: "UnAuthLayout",
    component: UnAuthLayout,
    children: [
      {
        path: "/login",
        name: "Login",
        component: Login,
      },
      {
        path: "/register",
        name: "Register",
        component: Register,
      },
      {
        path: "/forgot-password",
        name: "ForgotPassword",
        component: ForgotPassword,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    to.name === "Login" ||
    to.name === "Register" ||
    to.name === "ForgotPassword"
  ) {
    if (store.getters["auth/authenticated"]) {
      return next({
        name: "Home",
      });
    }
    next();
  } else if (!store.getters["auth/authenticated"]) {
    return next({
      name: "Login",
    });
  }
  next();
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
  let script = document.createElement("script");
  script.setAttribute("src", "/vendors/feather-icons/feather.min.js");
  script.setAttribute("type", "text/javascript");
  document.body.appendChild(script);

  script = document.createElement("script");
  script.setAttribute("src", "/js/template.js");
  script.setAttribute("type", "text/javascript");
  document.body.appendChild(script);
});

export default router;
